import { render, staticRenderFns } from "./IcoArrowLeft.vue?vue&type=template&id=92309a6a"
import script from "./IcoArrowLeft.vue?vue&type=script&lang=js"
export * from "./IcoArrowLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports